import React, {
  useEffect,
  useRef,
  useState,
  createContext,
  useContext,
} from "react";
import { Model } from "flexlayout-react";
import { StoreContext } from "../../../store/Store";
// import { getLayouts } from "../../../api/s3";
import { model as dmodel } from "../../../layout/models/storedValueModel";

export const LayoutContext = createContext(undefined);

export const LayoutProvider = ({ children, model }) => {
  const [store] = useContext(StoreContext);
  const { auth } = store;

  const layoutRef = useRef();

  const [state, setState] = useState({ refresh: true });

  useEffect(() => {
    if (auth) {
      const asyncfunction = async () => {
        // const res = await getLayouts(auth, "default");
        // const model = JSON.parse(res.Item.layout);
        const defaultState = {
          model: Model.fromJson(model ? model : dmodel),
          layout: layoutRef,
        };
        setState(defaultState);
      };
      asyncfunction();
    }
  }, [auth, model]);

  return state ? (
    <LayoutContext.Provider value={[state, setState]}>
      {children}
    </LayoutContext.Provider>
  ) : null;
};
